module.exports = __webpack_public_path__ + "50976ca4aebace05f009385c939b4662.svg";